// "Report unavailable" error card. Extracted verbatim from PaidReport.jsx (W2c).
export default function ReportError({ error }) {
  return (
    <div className="sf-container" style={{ padding: "80px 24px" }} data-testid="paid-report-error">
      <div className="sf-card">
        <div className="sf-eyebrow" style={{ color: "var(--sf-gold)" }}>Report unavailable</div>
        <p style={{ marginTop: 10 }}>{error}</p>
      </div>
    </div>
  );
}
